var Downloadcenter = function() {
	var self = this;

	this.downloads          = {};
	this.selectedDownloads  = {};
	this.$searchForm        = $('form[name=downloadcenter-search]');
	this.$downloadLink      = $('.downloadcenter .download-link');
	this.$downloadModal     = $('.downloadcenter-download-modal');
	this.$downloadStartLink = this.$downloadModal.find('.download-start-link');
	this.$downloadProgress  = this.$downloadModal.find('.download-progress');
	this.$downloadEmailForm = this.$downloadModal.find('form[name=mail-downloads]');

	this.groupDownloads = function(downloads) {
		var groups = {};

		$.each(downloads, function(fileId, downloadData) {
			var title = downloadData.title;

			if (!groups[title]) {
				groups[title] = {
					title: title,
					files: {}
				};
			}

			groups[title].files[fileId] = downloadData.filename
		});

		return groups;
	}

	this.initEvents = function() {
		$('.downloadcenter').on('click', '.downloadcenter-categories a', function(e) {
			e.preventDefault();
			var category = $(this).data('category');
			document.location.hash = category;
			$(this).addClass('active').closest('.downloadcenter-categories').find('a').not($(this)).removeClass('active');
			self.$searchForm.find('input[name=category]').val(category).trigger('change');
		});

		$('.downloadcenter .deselect-all-link').on('click', function(e) {
			e.preventDefault();
			self.deselectAllDownloads();
		});

		this.$downloadLink.on('click', function(e) {
			e.preventDefault();

			if (Object.keys(self.selectedDownloads).length == 0) {
				return false;
			}

			var $selectedList = self.$downloadModal.find('.downloads-selected ul');
			$selectedList.html('');

			$.each(self.groupDownloads(self.selectedDownloads), function(groupKey, groupData) {
				var $li = $('<li>');
				$('<div class="title">').html(groupData.title).appendTo($li);
				var $filenames = $('<div class="filenames">');
				$.each(groupData.files, function(fileId, filename) {
					var fileData = self.selectedDownloads[fileId] || {};
					$('<div class="filename">').text(filename + ' (' + (fileData.size || '?') + ')').appendTo($filenames);
				});
				$filenames.appendTo($li);
				$li.appendTo($selectedList);
			});

			// $.each(self.selectedDownloads, function(fileId, downloadData) {
			// 	var $li = $('<li>');
			// 	$('<div class="title">').html(downloadData.title).appendTo($li);
			// 	$('<div class="filename">').text(downloadData.filename).appendTo($li);
			// 	$selectedList.append($li);
			// });

			self.$downloadProgress.hide();
			self.$downloadEmailForm.find('form').show();
			self.$downloadModal.find('.result').hide();
        	self.$downloadModal.modal('show');
		});

		$(document).on('change', '.downloadcenter input[name^=downloads_selected]', function(e) {
			if ($(this).prop('checked')) {
				self.selectDownload($(this).val());
				self.flashDownloadLink();
			} else {
				self.deselectDownload($(this).val());
			}
		});

		$(document).on('click', '.downloadcenter .toggle-all', function(e) {
			e.preventDefault();

			$(this).toggleClass('active');
			$('.downloadcenter input[name^=downloads_selected]').prop('checked', $(this).hasClass('active')).trigger('change');
		});

		this.$downloadEmailForm.on('submit', function(e) {
			e.preventDefault();

			// Disable button and hide any result message
			self.$downloadModal.find('[type=submit]').addClass('loading').prop('disabled', true);
			self.$downloadModal.find('.result').slideUp('fast');

			// Add file id hidden inputs to the form
			$(this).find('input[name^=file_ids]').remove();
			$.each(self.selectedDownloads, function(fileId) {
				var $input = $('<input type="hidden" name="files[]">');
				$input.val(fileId);
				self.$downloadEmailForm.append($input);
			});

			$.post('/site/ajax/downloadcenter_send.php', $(this).serialize(), function(data) {
				// Show message
				if (data.result == 'error') {
					self.$downloadModal.find('.result.errors').html(data.message).slideDown('fast');
				} else {
					self.$downloadModal.find('.result.success').html(data.message).slideDown('fast');
				}

				// Enable button
				self.$downloadModal.find('[type=submit]').removeClass('loading').prop('disabled', false);
			});
		});

		this.$downloadStartLink.on('click', function(e) {
			e.preventDefault();
			self.startDownload();
		});
	};

	this.flashDownloadLink = function() {
		self.$downloadLink.addClass('flash');
		setTimeout(function() {
			self.$downloadLink.removeClass('flash');
		}, 300);
	};

	this.checkAllCategorySelected = function() {
		var self = this;
		var count = 0;
		var $btn = $('.downloadcenter .toggle-all');

		$.each(this.downloads, function(fileId) {
			if (self.selectedDownloads[fileId] !== undefined) {
				count++;
			}
		});

		var allOn  = count == Object.keys(this.downloads).length;
		var dataIf = allOn ? 'all-on' : '!all-on';

		$btn.toggleClass('active', allOn).find('[data-if]').addClass('hidden').filter('[data-if="' + dataIf + '"]').removeClass('hidden');
	};

	this.updateOverallSelected = function() {
		var count = Object.keys(this.selectedDownloads).length;
		var dataIf = count == 1 ? 'overall-check-count=1' : 'overall-check-count!=1';

		this.$downloadLink.find('[data-show="overall-check-count"]').text(count);
		this.$downloadLink.find('[data-if]').addClass('hidden').filter('[data-if="' + dataIf + '"]').removeClass('hidden');
		this.$downloadLink.toggleClass('disabled', count === 0);

		$('.downloadcenter .deselect-all-link').toggleClass('disabled', count === 0);
	};

	this.startDownload = function() {
		var self     = this;
		var zip      = new JSZip();
		var filename = "downloadcenter-downloads-" + (new Date().getTime()) + ".zip";
		var total    = Object.keys(self.selectedDownloads).length;
		var count    = 0;

		self.$downloadStartLink.addClass('loading').prop('disabled', true);
		self.$downloadProgress.show().find('.total').text(total);
		self.$downloadProgress.find('.count').text(count);
		self.$downloadProgress.find('.onzipstart').hide();

		// Download all files with a pause between every file
		var timeout = 0;

		$.each(self.selectedDownloads, function(fileId, downloadData) {
			setTimeout(function() {
				JSZipUtils.getBinaryContent(downloadData.url, function(err, data) {
					count++;

					if (err) {
						if (console.log) console.log("Could not add " + downloadData.filename, err);
						return;
					}

					// Add file to zip
					zip.file(downloadData.filename, data);
					self.$downloadProgress.find('.count').text(count);

					if (count == total) {
						self.$downloadProgress.find('.onzipstart').show();

						// Generate zip
						zip.generateAsync({type: "blob"}).then(function(content) {

							// Download zip
							saveAs(content, filename);
							self.$downloadStartLink.removeClass('loading').prop('disabled', false);
							self.$downloadProgress.find('.onzipstart').hide();
						});
					}
				});
			}, timeout);

			timeout += 100;
		});
	};

	this.initEvents();
	this.checkAllCategorySelected();
	this.updateOverallSelected();
};

Downloadcenter.prototype.selectDownload = function(fileId, saveSession) {
	if (this.downloads[fileId] === undefined) {
		return false;
	}

	if (this.selectedDownloads[fileId] === undefined) {
		this.selectedDownloads[fileId] = this.downloads[fileId];
	}

	$('.downloadcenter input[name^=downloads_selected][value="' + fileId + '"]').prop('checked', true);
	this.checkAllCategorySelected();
	this.updateOverallSelected();
};

Downloadcenter.prototype.deselectDownload = function(fileId) {
	delete this.selectedDownloads[fileId];
	$('.downloadcenter input[name^=downloads_selected][value="' + fileId + '"]').prop('checked', false);
	this.checkAllCategorySelected();
	this.updateOverallSelected();
};

Downloadcenter.prototype.deselectAllDownloads = function() {
	var self = this;

	$.each(this.selectedDownloads, function(fileId) {
		self.deselectDownload(fileId);
	});
};

Downloadcenter.prototype.loadDefaultCategory = function() {
	var self = this;

	if (document.location.hash == '') document.location.hash = $('.downloadcenter-categories a').first().data('category');
	// $('.downloadcenter-categories a[data-category="' + document.location.hash.substr(1).split(',')[0] + '"]').trigger('click');

	var category = document.location.hash.substr(1);

	document.location.hash = category;
	$('.downloadcenter-categories a[data-category="' + category.split(',')[0] + '"]').addClass('active');
	self.$searchForm.find('input[name=category]').val(category).trigger('change');
};

Downloadcenter.prototype.loadDownloads = function(downloads) {
	var self = this;
	this.downloads = downloads;

	$.each(this.selectedDownloads, function(fileId) {
		self.selectDownload(fileId, false);
	});
};

